import { Link, useLocation } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import { allCategories } from "@/lib/news";

export default function NotFound() {
  const location = useLocation();

  return (
    <SiteLayout>
      <div className="mx-auto flex w-full max-w-[1200px] flex-col items-center justify-center px-4 py-24 text-center md:px-6">
        <span className="font-heading text-7xl font-black tracking-tight text-primary-100 md:text-9xl">
          404
        </span>
        <h1 className="mt-4 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
          页面不存在或已调整
        </h1>
        <p className="mt-2 max-w-md text-sm leading-6 text-foreground-500">
          您访问的地址 <span className="font-label text-foreground-700">{location.pathname}</span> 暂时无法找到，
          不妨从下方入口继续浏览黑料信息。
        </p>

        <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-label text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
          >
            返回首页
          </Link>
        </div>

        <div className="mt-10 w-full max-w-2xl">
          <p className="mb-3 text-xs text-foreground-400">或前往分类浏览</p>
          <div className="flex flex-wrap items-center justify-center gap-2">
            {allCategories.map((category) => (
              <Link
                key={category.id}
                to={`/category/${category.id}`}
                className="rounded-md border border-background-200 bg-background-50 px-3 py-1.5 text-sm font-label text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600 cursor-pointer"
              >
                {category.name}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </SiteLayout>
  );
}